/* eslint-disable  */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { api } from '#/apis';

const fetchEvals = async date => {
    const { data } = await api.post('/evals/daterange', { quarterDate: date });

    return data;
};

const deleteEvalQuestion = async evalQuestionId => {
    const { data } = await api.delete(`/eval-questions/${evalQuestionId}`)

    return data;
}

// const createEval = async payload => {
//     const { data } = await api.post('/evals', payload);

//     return data;
// };

// const updateEval = async payload => {
//     const { data } = await api.put(`/evals/${payload.id}`, payload);

//     return data;
// };

const deleteEval = async evalId => {
    const { data } = await api.delete(`/evals/${evalId}`);

    return data;
};

const getEvalDates = async () => {
    const { data } = await api.get('/evals/dates');

    return data;

};

const generateEvals = async payload => {

    const { data } = await api.post('/evals/generate', payload);

    return { data };
};

const sendEvalReminders = async () => {
    const { data } = await api.get('/evals/sendEvalReminderEmails');

    return data;
};

export const useFetchEvalDates = (queryOptions = {}) => useQuery('eval-dates', getEvalDates, queryOptions);
export const useSendEvalReminders = (queryOptions = {}) => useQuery('eval-reminders', sendEvalReminders, queryOptions);


export const useFetchEvals = (date, queryOptions = {}) => useQuery(['evals', date], () => fetchEvals(date), queryOptions);
export const useDeleteEval = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(evalId => deleteEval(evalId), {
        onSuccess: () => {
            queryClient.invalidateQueries('evals');
        },
        ...queryOptions
    });
};

export const useGenerateEvals = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => generateEvals(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('evals');
            queryClient.invalidateQueries('eval-dates');
        },
        ...queryOptions
    });
};


export const useDeleteEvalQuestion = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(evalQuestionId => deleteEvalQuestion(evalQuestionId), {
        onSuccess: () => {
            queryClient.invalidateQueries('title');
        },
        ...queryOptions
    });
};

// export const useCreateEval = (queryOptions = {}) => {
//     const queryClient = useQueryClient();

//     return useMutation(payload => createEval(payload), {
//         onSuccess: () => {
//             queryClient.invalidateQueries('evals');
//         },
//         ...queryOptions
//     });
// };

// export const useUpdateEval = (queryOptions = {}) => {
//     const queryClient = useQueryClient();

//     return useMutation(payload => updateEval(payload), {
//         onSuccess: () => {
//             queryClient.invalidateQueries('evals');
//         },
//         ...queryOptions
//     });
// };
